module.exports = __webpack_public_path__ + "img/excel.5b9bd695.png";